import { Typography, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';

import { ReactComponent as Group130 } from '../../assets/modalKYX/Group130.svg';
import { ReactComponent as Group99 } from '../../assets/modalKYX/Group99.svg';

const useStyles = makeStyles({
    dialogBody: {
        display: 'flex',
        flexDirection: 'row',
        minHeight: '600px',
        height: '100%',
        backgroundColor: '#F7F9FC',
        justifyContent: 'center'
    },
    content: {
        textAlign: 'center',
        padding: '2em',
        paddingTop: '5em'
    },
    contentTitle: {
        marginTop: '1em',
        fontWeight: '700!important'
    },
    next: {
        color: 'white!important',
        borderRadius: '25px!important',
        marginLeft: '1em',
        padding: '.5em 3em!important',
        background: '#1BABE2!important'
    },
    vertical: {
        borderLeft: '1px solid lightgrey',
        height: '60px',
        width: '10px',
        position: 'relative',
        left: '50%',
        marginBottom: '1em'
    },
    kybStart: {
        marginTop: '1em',
        fontWeight: '700!important',
        color: 'lightgrey',
        marginBottom: '.5em!important'
    }
});

export const KYCSubmitted = ({ openModalKYB }) => {
    const classes = useStyles();

    return (
        <Box className={classes.dialogBody}>
            <Box
                className={classes.content}
                sx={{
                    width: {
                        lg: '50%',
                        md: '50%',
                        sm: '100%',
                        xs: '100%'
                    }
                }}>
                <Group130 />
                <Typography variant="h5" className={classes.contentTitle}>
                    Thank you for verifying yourself. Next, please verify your business.
                </Typography>
                <div className={classes.vertical}></div>
                <Group99 />
                <Typography variant="h5" className={classes.kybStart}>
                    Verify your business
                </Typography>
                <Button variant="contained" onClick={openModalKYB}>
                    Start application
                </Button>
            </Box>
        </Box>
    );
};
